<template>
  <div style="background: url('/acnImg/home/intelligence/bg.png')">
    <div :class="[pc ? 'mw1200' : 'm20']" :style="{ padding: pc ?'85px 0 50px 0' : '70px 0 50px 0' }">
      <div style="margin-bottom: 50px">
        <h1 :class="{f36: !pc}" style="color: #eddc99;font-size: 28px;margin: 0">{{ $t('home.intelligence.p1') }}</h1>
        <p :class="{f20: !pc}" v-html="pc ? $t('home.intelligence.p2') : $t('home.intelligence.p2').replace(/&lt;br>/, '')" :style="{lineHeight: pc?'1.2':'26px'}" style="color: #a6a6a6;font-family: MonotypeCorsiva,楷体,serif;font-size: 18px"></p>
      </div>
      <div style="display: flex;justify-content: space-between;flex-wrap: wrap">
        <div class="intelligence" v-for="(item, index) in $t('home.intelligence.list')" :key="index" style="margin-bottom: 50px" :style="{width: pc?'30%':'80%'}">
          <img class="img_trans" :src="item.img" width="100%"/>
          <h1 :class="{f26: !pc}" style="margin-bottom: 10px;font-weight: 400">{{ item.p1 }}</h1>
          <p :class="{f20: !pc}" :style="{minHeight: pc?'230px': '180px', lineHeight: pc?'23px':'30px'}">{{ item.p2 }}</p>
          <a-button :class="{f20: !pc}" :style="{margin: pc?'0':'30px 0 40px 0'}" @click="$router.push(item.link)">{{isEn?'View More':'查看更多'}}</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'intelligence',
  computed: {
    ...mapGetters(['pc', 'isEn'])
  }
}
</script>

<style lang="less">
  .intelligence {
    img {
      margin-bottom: 30px;
    }

    h1 {
      font-size: 20px;
      color: rgb(237, 220, 153);
      font-weight: 100;
    }

    p {
      font-size: 15px;
      color: #a6a6a6;
    }

    button {
      height: 40px;
      width: 120px;
      background: transparent;
      color: #cccccc;
      border: 1px solid #9798A4;
      font-size: 15px;

      &:hover {
        background: #580606;
        color: #eddc99;
      }
    }
  }
</style>
